
import { Component, Vue } from 'vue-property-decorator'
import SSwitch from '@/components/SSwitch'
import GoodsPackageSingle from '@/views/goodsManage/commodity/template/GoodsPackageSingle.vue'
import { goodsBannerImage, goodsSpecificationListEvent, goodsSpecDelete, goodsCodeEvent, goodsPackageListEvent, multiSpecEvent } from '@/constant/event'
import { goodsPackageDto, goodsSpecificationDto, goodsImageDto, goodsDetailDto } from '@/api/goods'
import { LevelListDto } from "@/api/customerManage"
import { getMerchantsLevelList } from "@/api/commodity"
import { FileDTO, upFile, fileTypes } from '@/api/commonConfig'
import { downloadUrl, handleFill } from '@/utils/util'
import { assemble } from '@/utils/assemble'
import { confirm } from '@/utils/decorator'

@Component({
  components: {
    SSwitch,
    GoodsPackageSingle
  }
})
export default class GoodsPackage extends Vue {
  downloadUrl = downloadUrl
  handleFill = handleFill
  $refs!: {
    goodsPackageSingle: GoodsPackageSingle
  }
  labelWidth = 100
  goodsSpecsMap = new Map()
  goodsPackageList: goodsPackageDto[] = []
  goodsSpecificationList: goodsSpecificationDto[] = []
  goodsImageList: goodsImageDto[] = []
  goodsCode = ''
  goodsSpecTotal = 0
  multiSpec = false
  initState = true // 初始化状态
  levelList: LevelListDto[] = []

  get $isCopy () {
    return 'copy' === this.$route.query.op as string
  }

  async created () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this
    this.$eventBus.$on(goodsSpecDelete, ((data: string[]) => {
      that.goodsPackageList.forEach((item, packageIndex: number) => {
        data.forEach(attrValueCode => {
          if (item.packageName!.includes(attrValueCode)) {
            that.goodsPackageList[packageIndex] = undefined
          }
        })
      })
      that.goodsPackageList = that.goodsPackageList.filter(Boolean)
    }))
    this.$eventBus.$on(goodsBannerImage, (data: goodsImageDto[]) => {
      this.goodsImageList = data
      this.goodsPackageList.forEach(item => {
        if (!item.custonMainImg) {
          item.mainImageUrl = this.goodsImageList[0].imageUrl
          item.mainImageSize = this.goodsImageList[0].imageSize as number
          item.mainImageUrlList = [
            {
              url: downloadUrl(this.goodsImageList[0].imageUrl)
            }
          ]
        }
      })
    })
    this.$eventBus.$on(goodsCodeEvent, (data: string) => {
      this.goodsCode = data
      this.goodsPackageList.forEach((item, index: number) => {
        item.packageCode = this.initPackCode(index + 1)
      })
    })
    await this.getLevelList()
    this.goodsPackageList = []
    this.addGoodsPackage([])
    this.$eventBus.$on(goodsSpecificationListEvent, ((data, multiSpec: boolean) => {
      this.multiSpec = multiSpec
      if (multiSpec) {
        // this.goodsPackageList = []
        this.goodsSpecificationList = data
        this.assembleGoodsPackage()
      } else {
        let goodsPackageList: goodsPackageDto = {}
        this.goodsPackageList.some(item => {
          if (item.packageStatus === 1) {
            goodsPackageList = item
          }
          return item.packageStatus === 1
        })
        goodsPackageList.packageName = this.transformPackage(goodsPackageList.packageName as string)
        this.goodsPackageList = [goodsPackageList]
        if (!this.goodsPackageList[0]) this.addGoodsPackage([])
        this.goodsSpecTotal = 0
      }
    }))
  }
  initPackCode (index?: number) {
    return `${this.goodsCode}-${index || this.goodsPackageList.length + 1}`
  }
  assembleGoodsPackage () {
    // 如果规格个数有变动，清空套餐信息重新生成
    console.log(`${this.goodsSpecTotal}, ${this.goodsSpecificationList.length}`)
    if (this.goodsSpecTotal !== this.goodsSpecificationList.length) {
      this.goodsPackageList = []
    }
    this.goodsSpecTotal = this.goodsSpecificationList.length
    if (!this.goodsSpecTotal) return false
    const allGoodsPackage = this.getAllGoodsPackage()
    const goodsSpecs = this.goodsSpecificationList.map(item => {
      return item.specValueList.map(item => {
        this.goodsSpecsMap.set(item.attrValueCode, item)
        return item.attrValueCode
      })
    })
    console.log(assemble(goodsSpecs, this.goodsSpecTotal))
    const assembleGoodsSpecsList = assemble(goodsSpecs, this.goodsSpecificationList.length)
    assembleGoodsSpecsList.forEach((item: string[]) => {
      if (!allGoodsPackage.includes(item.join(','))) {
        this.addGoodsPackage(item)
      }
    })
    this.goodsPackageListEvent()
  }
  addGoodsPackage (packageName: string[]) {
    const mainImage = this.goodsImageList[0]
    this.goodsPackageList.push({
      serialNumber: this.goodsPackageList.length + 1,
      packageName: packageName.join(','),
      packageCode: this.initPackCode(),
      barcode: '',
      weight: '',
      packageStatus: 1,
      isUseCusLevelPrice: 1,
      isUseCusPrice: 1,
      isSyncOther: '0',
      cusLevelPriceList: JSON.parse(JSON.stringify(this.levelList)),
      cusPriceList: [],
      mainImageUrlList: [
        {
          url: mainImage ? downloadUrl(mainImage.imageUrl) : ''
        }
      ],
      mainImageUrl: mainImage ? mainImage.imageUrl : '',
      mainImageSize: mainImage ? mainImage.imageSize as number : null
    })
  }
  goodsPackageListEvent () {
    this.$eventBus.$emit(goodsPackageListEvent, JSON.parse(JSON.stringify(this.goodsPackageList)))
  }
  getAllGoodsPackage () {
    return this.goodsPackageList.map(item => item.packageName)
  }
  // 转换套餐名称
  transformPackage (val: string) {
    let arr = val.split(',')
    arr = arr.map((item, index) => {
      let data = this.goodsSpecificationList[index].specValueList.filter(items => {
        return item === items.attrValueCode
      })
      return data ? (data[0] ? data[0].attrValue : '') : ''
    })
    return arr.join(',')
  }
  afterRead (file: FileDTO, index: number) {
    const formData = new FormData()
    formData.append('fileStream', file.file)
    formData.append('fileType', fileTypes.goodsBanner)
    upFile(formData).then((res) => {
      const file = res.data
      this.goodsPackageList[index].mainImageUrl = file.orderFileUrl
      this.goodsPackageList[index].mainImageBase64 = downloadUrl(file.orderFileUrl),
        this.goodsPackageList[index].mainImageSize = Number(file.orderFileSize)
      this.goodsPackageList[index].custonMainImg = true
    })
  }
  toSingleGoodsPackage (data: goodsPackageDto, index: number) {
    this.$eventBus.$emit('currentPage', 5)
    this.$refs.goodsPackageSingle.showModal({
      data: JSON.parse(JSON.stringify(data)),
      index,
      goodsSpecificationList: this.goodsSpecificationList,
      multiSpec: this.multiSpec,
      upGoodsPackageLength: this.getAllUpGoodsPackage().length
    })
  }
  saveSingleGoodsPackage (res: { data: goodsPackageDto, index: number }) {
    this.$eventBus.$emit('currentPage', 1)
    this.$set(this.goodsPackageList, res.index, res.data)
    if (Number(res.data.isSyncOther)===1) this.syncOtherPackage(JSON.parse(JSON.stringify(res.data)))
  }
  syncOtherPackage (data: goodsPackageDto) {
    this.goodsPackageList.forEach(item => {
      item.cusLevelPriceList = data.cusLevelPriceList
      item.cusPriceList = data.cusPriceList
      item.marketPrice = data.marketPrice
      item.referPrice = data.referPrice
      item.isUseCusPrice = data.isUseCusPrice
    })
  }
  /**
   * 删除套餐
   */
  @confirm('提示', '确定删除该商品套餐吗？')
  deleteGoodsPackage (index: number) {
    // this.goodsPackageList.splice(index, 1)
    if (this.getNoDeleteGoodsPackageList().length <= 1) {
      this.$toast('请至少保留一种规格的商品')
      return false
    }
    this.goodsPackageList[index].packageStatus = 3
    this.updateGoodsPackageSerialNumber()
    this.goodsPackageListEvent()
  }
  /**
   * 更新商品规格列表序号值以及商品套餐编码
   */
  updateGoodsPackageSerialNumber () {
    let serialNumber = 0
    this.goodsPackageList.forEach((item, index: number) => {
      serialNumber = index + 1
      item.serialNumber = serialNumber
      item.packageCode = this.initPackCode(serialNumber)
    })
  }
  /**
   * 获取未删除的商品套餐列表
   */
  getNoDeleteGoodsPackageList () {
    return this.goodsPackageList.map(item => {
      if (Number(item.packageStatus) !== 3) return item
    }).filter(Boolean)
  }
  /**
   * 获取所有上架套餐
   */
  getAllUpGoodsPackage () {
    return this.goodsPackageList.map(item => {
      if (Number(item.packageStatus) === 1) return item
    }).filter(Boolean)
  }
  validatEmptyOrderPrice () {
    return new Promise((resolve,reject) => {
      let emptyOrderPrice = this.goodsPackageList.some(priceForm => {
        return priceForm.cusLevelPriceList!.some(item => {
          // return Number(item.orderPrice) === 0
          // 已删除的套餐信息不做价格设置为0 的判断
          return Number(item.orderPrice) === 0 && Number(priceForm.packageStatus) !== 3
        })
      })
      let emptyCusOrderPrice = this.goodsPackageList.some(priceForm => {
        return priceForm.cusPriceList!.some(item => {
          return Number(item.orderPrice) === 0
        })
      })
      if (emptyOrderPrice || emptyCusOrderPrice) {
        this.$dialog.alert({
          title: '提示',
          message: '检测到部分套餐订货价为0，提交失败。'
        }).then(() => {
          reject('提交失败')
        })
      } else {
        resolve(true)
      }
    })
  }
  setData (data: goodsDetailDto) {
    this.initState = true
    this.goodsSpecificationList = data.goodsSpecificationList
    this.goodsSpecTotal = this.goodsSpecificationList.length || 0
    this.goodsPackageList = data.goodsPackageList
    this.multiSpec = !!(data.isMultiSpec || data.isMultiSpec)
    this.goodsPackageList.forEach((item, index: number) => {
      item.goodsPackageId = item.goodsPackageId || item.packageId
      item.isSyncOther = '0'
      if (this.$isCopy) {
        item.packageCode = item.packageCode.replace(item.packageCode.substr(0, item.packageCode.indexOf('-')), this.goodsCode)
      }
    })
    this.$nextTick(() => {
      this.initState = false
    })
  }
  handleSubmit () {
    return new Promise((resolve) => {
      this.validatEmptyOrderPrice().then(() => {
        if (!this.getAllUpGoodsPackage().length) {
          this.$toast('请至少上架一个套餐')
          return false
        }
        const valid = this.goodsPackageList.every(item => {
          item.isUseCusLevelPrice = item.isUseCusLevelPrice || item.isUseLevelPrice
          item.isUseCusPrice = item.isUseCusPrice ? 1 : 0
          return !!(item.barcode || item.mainImageUrl)
        })
        if (valid) {
          resolve({
            goodsPackageList: JSON.parse(JSON.stringify(this.goodsPackageList))
          })
        } else {
          this.$toast('请完善商品套餐信息')
        }
      })
    })
  }
  /**
   * 获取客户级别列表
   */
  getLevelList () {
    return new Promise((resolve) => {
      getMerchantsLevelList({ showLoading: false }).then((res) => {
        this.levelList = res.data.levelList || []
        this.levelList.forEach((item, index: number) => {
          this.$set(this.levelList[index], 'orderPrice', 0)
          this.$set(this.levelList[index], 'minimum', 1)
          item.customerLevelId = item.customerLevelId || item.levelId
        })
        resolve(true)
      })
    })
  }
  /**
   * 商品套餐信息界面原生返回功能调用
   */
  handlPackageAppCancel(){
    this.$refs.goodsPackageSingle.handleBack()
  }

  /**
   * 商品套餐信息按客户级别定价界面原生返回功能调用
   */
  handlPriceAppCancel(){
    this.$refs.goodsPackageSingle.handlePriceBack()
  }

  /**
   * 商品套餐信息按客户定价界面原生返回功能调用
   */
  handlPricesAppCancel(){
    this.$refs.goodsPackageSingle.handlePricesBack()
  }
}
